import { CaseDto, ProjectDto } from '@app/shared/models/contracts/project-dto';
import { OpmForecastDto } from '../models/contracts/opm-calculation-results-dto';
import { conditionalConvertNanToZero } from './middlewares';

export const getOpmForecastProbabilityWeightedValue = ({
  forecasts,
  getValue,
}: {
  forecasts: OpmForecastDto[];
  getValue: (props: {
    forecasts: OpmForecastDto[];
    forecast: OpmForecastDto;
  }) => number | null | undefined;
}) =>
  forecasts.reduce((forecastWeightedValue, forecast) => {
    const value = getValue({
      forecasts,
      forecast,
    });

    if (value === undefined || value === null || forecast.probability === null) {
      return NaN;
    }

    return forecastWeightedValue + forecast.probability * value;
  }, 0);

export const getCaseProbabilityWeightedValue = ({
  project,
  getValue,
  convertNanToZero = false,
}: {
  project: ProjectDto;
  getValue: (props: { caseItem: CaseDto }) => number | null | undefined;
  convertNanToZero?: boolean;
}) =>
  project.pwermInput.cases.reduce((caseWeightedValue, caseItem) => {
    const value = getValue({
      caseItem,
    });

    if (value === undefined || value === null || caseItem.probability === null) {
      return NaN;
    }

    // replace any NaN values coming from individual cases so the case-weighted average is not affected
    const boundedValue = conditionalConvertNanToZero(convertNanToZero, value);
    return caseWeightedValue + (caseItem.probability / 100) * boundedValue;
  }, 0);
